import React, { useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { addNewHighlight, getPromosAndHighlightLoading } from '../../features/promos-highlights.store';
import get from 'lodash.get';
import to from 'await-to-js';
import SubPageLayout from './helpers/SubPageLayout';
import { Button } from 'antd';
import FormSection from './helpers/FormSection';
import { Form, Formik } from 'formik';
import FormField from './helpers/FormField';
import { Uploader } from './helpers/Uploader';
import * as Yup from 'yup';
import { FoodCategoriesDropdown } from './helpers/enums-dropdown';

const HighlightAdd = () => {
  const history = useHistory();
  const loading = useSelector(getPromosAndHighlightLoading);
  const dispatch = useDispatch();
  const imageUploadRef = useRef();

  const onSubmit = async (values) => {
    const image = get(imageUploadRef, ['current', 'fileList', 0, 'originFileObj'], null);
    const [err] = await to(dispatch(addNewHighlight({ formValue: values, image })).unwrap());
    if (!err) {
      history.push('/highlights');
    }
  };

  return (
    <SubPageLayout title="Add New Highlight" extra={<Button onClick={() => history.goBack()}>Cancel</Button>}>
      <FormSection title="Add your new highlight information and submit">
        <Formik
          initialValues={{ foodCategory: '' }}
          onSubmit={onSubmit}
          className="d-flex f-col"
          validationSchema={HighlightValidator}
        >
          <Form>
            <div className="d-flex">
              <div className="flex space-right">
                <FormField
                  name="foodCategory"
                  labelText="Food Category"
                  placeholder="Select here"
                  InputComp={FoodCategoriesDropdown}
                />
              </div>
              <div className="flex">
                <Uploader
                  accept="image/*"
                  beforeUpload={() => Promise.reject()}
                  className="w-200px h-200px"
                  maxCount={1}
                  ref={imageUploadRef}
                />
              </div>
            </div>
            <div className="d-flex jc-end space-top-p space-bottom">
              <Button>clear</Button>
              <Button type="primary" htmlType="submit" className="space-left" loading={loading}>
                Submit
              </Button>
            </div>
          </Form>
        </Formik>
      </FormSection>
    </SubPageLayout>
  );
};

const HighlightValidator = Yup.object({
  foodCategory: Yup.string().required('Required'),
});

export default HighlightAdd;
